import React from 'react';
import { Form, useFormState } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { ASSISTANTS_CATEGORY, GENIE_EVALUATE_TYPE, PROJECT_TYPES } from '../../../../../constants';
import validate from '../../../../../utils/validate';
import { replyYopValidation } from '../../../../../scout-new/components/generation-section/components/repliesForm/replyValidation';
import RepliesFormInner from '../../../../../scout-new/components/generation-section/components/repliesForm/RepliesFormInner';

function RepliesForm({ onReply, assistantInput, projectType }) {
  const { id } = useParams();
  const dispatch = useDispatch();

  const generateFormValues = useFormState().values;

  const channels = useSelector((state) => state[projectType === PROJECT_TYPES.GENIE_GO ? 'genieGo' : 'genie'].channels);
  const isFormLoading = useSelector(
    (state) => state[projectType === PROJECT_TYPES.GENIE_GO ? 'genieGo' : 'genie'].isFormLoading,
  );
  const isResetting = useSelector(
    (state) => state[projectType === PROJECT_TYPES.GENIE_GO ? 'genieGo' : 'genie'].isResetting,
  );

  const evaluateActions = useSelector(
    (state) => state[projectType === PROJECT_TYPES.GENIE_GO ? 'genieGo' : 'genie'].evaluateActions,
  );
  const isEvaluatingGenMessages = evaluateActions[GENIE_EVALUATE_TYPE.GENERATED].pending;

  const repliesFormInitialValues = {
    hint: channels[ASSISTANTS_CATEGORY.GENERATE_ALL]?.hint,
    reply: '',
  };

  const handleReplies = (values) => {
    dispatch(onReply({ id, reply: values.reply, assistantId: assistantInput.value?.id, generateFormValues }));
  };

  return (
    <Form
      initialValues={repliesFormInitialValues}
      onSubmit={handleReplies}
      subscription={{ submitting: true, pristine: true }}
      validateOnBlur={false}
      validate={(values) => validate(values, replyYopValidation())}
      render={({ handleSubmit }) => (
        <RepliesFormInner onSubmit={handleSubmit} disabled={isFormLoading || isResetting || isEvaluatingGenMessages} />
      )}
    />
  );
}

export default RepliesForm;
